import { UserClient } from '../types'

export const upload = (base: UserClient) => (attachment: any, onUploadProgress?: (progressEvent: any) => void) => {
  const formData = new FormData();   

  formData.append('attachment', attachment);
  
  return base.requester.post<any>('/uploads', formData, { withCredentials: true, onUploadProgress })
}

